module.exports = __webpack_public_path__ + "img/advantage01.796673c0.svg";